/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFetch } from '@/hooks/useFetch';
import { Address } from '@/types/common';

export const LocalizationRepository = {
  getGeoLocation: async ({ latitude, longitude }: { latitude: number; longitude: number }) => {
    const data = await useFetch(
      `https://nominatim.openstreetmap.org/reverse?format=geojson&lat=${latitude}&lon=${longitude}`,
      null,
      'GET',
      null,
      true
    );

    const { features }: any = data;

    const address = features ? features[0].properties.address : null;

    const newAddress: Address = {
      street: address?.road,
      number: address?.house_number,
      neighborhood: address?.neighbourhood,
      city: address?.city,
      state: address?.state,
      country: address?.country,
      zipCode: address?.postcode
    };

    return newAddress;
  }
};
